// extracted by mini-css-extract-plugin
module.exports = {"Content":"App_Content__ZaMNr","Sider":"App_Sider__VmQ60","Header":"App_Header__ZS1m2","Footer":"App_Footer__XLEFd","AdminMenu":"App_AdminMenu__3CXnn"};